import { useEffect, useState } from 'react'
import { StructType, useStructTypes } from './useStructTypes'

export const useCurrentStructType = (currentTypeId) => {
  const allStructTypes = useStructTypes()

  const [currentType, setCurrentType] = useState<StructType | undefined>()

  useEffect(() => {
    if (!allStructTypes || !currentTypeId) return
    setCurrentType(allStructTypes.find((t) => t.id === currentTypeId))
  }, [currentTypeId, allStructTypes])

  return {
    currentTypeId,
    currentType,
    allStructTypes,
  }
}
